export { default as PlayAltOutlineIcon } from './PlayAltOutlineIcon';
